import { useLoaderData as useRouterLoaderData } from 'react-router-dom';

export const useLoaderData = <T>() => {
  return useRouterLoaderData() as T;
};
